import PageHeading from "@/presentation/ui/layouts/page/PageHeader";
import { EmptyState, Heading, Icons, Paragraph } from "@ir/ui";
import { Fragment } from "react/jsx-runtime";

const WorkspacePermissionError: React.FC = () => {
  return (
    <Fragment>
      <PageHeading title="Permission Denied" />
      <EmptyState
        className="bg-white border-1 border-color-grey-25 px-4 py-5 m-4"
        icon={Icons.InfoOctagon}
        title={
          <Heading level={6} className="text-grey-700 font-bold mt-3">
            You do not have permission to access this page
          </Heading>
        }
        description={<Paragraph className="text-grey-500 font-regular mb-0">Please contact your Administrator to get access to this page.</Paragraph>}
      />
    </Fragment>
  );
};
export default WorkspacePermissionError;
